module.exports = __webpack_public_path__ + "static/media/grph-stat2-44.7525c1b4.svg";